// extracted by mini-css-extract-plugin
export default {"menuItemText":"HomeLeftSideMenu_menuItemText__adgUg","childDrawer":"HomeLeftSideMenu_childDrawer__mz19G"};